var now = +new Date();
var index = 0;
export default function uid() {
  return "u-upload-".concat(now, "-").concat(++index);
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-upload/src/uid.js